// extracted by mini-css-extract-plugin
export default {"Picture":"Picture_Picture__5JTQE","Picture__loading":"Picture_Picture__loading__7CzS4"};